import { render, staticRenderFns } from "./VideoModal.vue?vue&type=template&id=7652c867&scoped=true&"
import script from "./VideoModal.vue?vue&type=script&lang=js&"
export * from "./VideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7652c867",
  null
  
)

export default component.exports